module.exports = __webpack_public_path__ + "static/media/bccsa_logo.86c758f5.png";